module.exports = __webpack_public_path__ + "static/img/default.17c846b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/units/s_tree3_adult/default.png
// module id = UX/r
// module chunks = 1